export default "__VITE_ASSET__BvrgDgNm__"